import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { PaginationOptions } from '../conf/pagination-options.interface';
import { BreakpointObserver } from '@angular/cdk/layout';
import { APP_ENV, ENV_BLOCKED_ACCESS } from '../conf/app_env';
import { DAY_NIGHT_OPTIONS, INT_EXT_OPTIONS } from '../conf/scene';
import { Sketchpad } from 'src/assets/js/sketchpad.js'
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

@Injectable({
	providedIn: 'root'
})
export class GlobalService {
	updateCode: boolean = false;
	service_url: string = environment.apiUrl;
	adobe_cred: string = (window as any).ADOBE_CLIENT_ID || '';

	changesSessionToken$ = new BehaviorSubject<string>(null);
	loading: boolean = false;
	session_token: string = '';
	user: any;
	httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json'
		}),
		withCredentials: true
	};
	version: string = 'V-31.03 2026-08-10 A22-secrets-v2'
	actualYear: number = new Date().getFullYear();

	showContext: boolean = false;
	contextmenuy: string = '0px';
	contextmenux: string = '0px';
	modifications: any = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'U', 'V', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AU', 'AV', 'AX', 'AY', 'AZ'];
	filesToUpload: any = [];
	uploadFiles: any = [];
	upladingImage: boolean = false;
	isMobile$ = new BehaviorSubject<boolean>(false);

	lastRoutes = {
		'daily_plan': 'shooting-schedules',
		'color-box': 'chapters',
		'detail-shooting-scene': 'shooting'
	}

	home_pages: any = [
		{ 'name': 'Home', 'secure_module': 0, 'link': ['/home'] },
		// { 'name': 'Pipeline', 'secure_module': 1, 'link': ['/pipeline'], 'hiddenOnEnv': [APP_ENV.Domestic] },
		{ 'name': 'Timeline', 'secure_module': 50, 'link': ['/timeline'], 'hiddenOnEnv': [APP_ENV.Domestic] },
		{ 'name': 'Projects', 'secure_module': 2, 'link': ['/projects'] },
		{ 'name': 'Finance', 'secure_module': 28, 'link': ['/finance'] },
		{ 'name': 'Admin', 'secure_module': 15, 'link': ['/admin'] },
		{ 'name': 'Position Matrix', 'secure_module': 58, 'link': ['/charge-matrix'] }, //Falta permiso
	]
	finance_pages: any = [
		// { 'name': 'Forecast', 'secure_module': 30, 'link': ['forecast'] },
		{ 'name': 'Catering', 'secure_module': 34, 'link': ['caterings'] },
		{ 'name': 'Services', 'secure_module': 34, 'link': ['services'] },
		{ 'name': 'Cash advance', 'secure_module': 31, 'link': ['cash-advance'] },
		// {'name':'Expenses', 'secure_module':34, 'link':['expenses']},
		{ 'name': 'Vendors', 'secure_module': 32, 'link': ['vendors'] },
		// { 'name': 'Contracts', 'secure_module': 35, 'link': ['contracts'] },
		{ 'name': 'Config', 'secure_module': 33, 'link': ['config'], 'notInProject': true },
		{ 'name': 'Budget', 'secure_module': 30, 'link': ['budget'], 'justInProject': true },//Falta permiso
		// { 'name': 'Budget master', 'secure_module': 0, 'link': ['budget'], 'notInProject': true }, //Falta permiso
	]
	breakdown_pages: any = [
		{'name': 'Chapters', 'secure_module': 6, 'link': ['chapters']},
		{'name': 'Scenes', 'secure_module': 7, 'link': ['scenes']}
	]
	production_plan_pages: any = [
		{ 'name': 'Timeline', 'secure_module': 60, 'link': ['timeline'] },
		{ 'name': 'Calendar', 'secure_module': 26, 'link': ['calendar'] },
		{ 'name': 'Parameters', 'secure_module': 4, 'link': ['parameters'] },
		{ 'name': 'Production plan', 'secure_module': 5, 'link': ['production-plan'] },
	]
	elements_pages: any = [
		{ 'name': 'Characters', 'secure_module': 10, 'link': ['characters'] },
		{ 'name': 'Locations', 'secure_module': 11, 'link': ['locations'] },
		{ 'name': 'Elements', 'secure_module': 13, 'link': ['elements'] },
		{ 'name': 'Events', 'secure_module': 54, 'link': ['events'], 'hiddenOnEnv': [APP_ENV.Domestic] },
		{ 'name': 'Songs', 'secure_module': 53, 'link': ['songs'], 'hiddenOnEnv': [APP_ENV.Domestic] },
		{ 'name': 'Interfaces', 'secure_module': 52, 'link': [ 'interfaces'], 'hiddenOnEnv': [APP_ENV.Domestic] },
		{ 'name': 'Brands', 'secure_module': 36, 'link': ['brands'] }
	]
	production_pages: any = [
		{ 'name': 'Stripboard', 'secure_module': 51, 'link': [ 'stripboard'] },
		{ 'name': 'Units', 'secure_module': 27, 'link': ['units'] },
		{ 'name': 'Requirements', 'secure_module': 57, 'link': ['requirements'] },
		{ 'name': 'Shooting schedule', 'secure_module': 14, 'link': ['shooting-schedules'] }
	]
	post_pages: any = [
		{ 'name': 'Timeline', 'secure_module': 60, 'link': ['timeline'] },
		{ 'name': 'Episodes', 'secure_module': 39, 'link': ['episodes'] },
		{ 'name': 'Clips', 'secure_module': 38, 'link': ['clips'] },
		{ 'name': 'Assets', 'secure_module': 49, 'link': ['assets'] },
	]
	continuity_pages: any = [
		{ 'name': 'Continuity characters', 'secure_module': 22, 'link': ['characters'] },
		{ 'name': 'Continuity days', 'secure_module': 22, 'link': ['days'] },
		{ 'name': 'Continuity sets', 'secure_module': 22, 'link': ['location-sets'] },
		{ 'name': 'All images sets', 'secure_module': 22, 'link': ['sets'] },
		{ 'name': 'All images characters', 'secure_module': 22, 'link': ['all'] },
	]
	requirements_pages: any = [
		{ 'name': 'Services', 'secure_module': 19, 'link': ['services'] },
		{ 'name': 'Caterings', 'secure_module': 19, 'link': ['caterings'] },
	]
	regex: any = {
		'scene': "\\d{1,3}(\\.\\d{1,2})?",
		'year': "\\d{4}",
		'accountCode': "\\d{4,5}",
		'dayHistory': "[0-9 A-Z a-z -.]{1,4}",
		'page': "([1-9]([\\d]+)?){1,3}",
		'number': "[1-9]([\\d]+)?",
		'phone': /^[0-9]{10}$/,
		'fivetosix': "[5-6]{1}",
		'numberZero': "[0-9]([\\d]+)?",
		'email': "([A-Z|a-z|0-9|\-!#$%&'*+_](\.){0,1})+[A-Z|a-z|0-9|\-!#$%&'*+_]\@([A-Z|a-z|0-9|\-!#$%&'*+_])+((\.){0,1}[A-Z|a-z|0-9]){1}\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?",
		'safe_text': "",
		'link': "((https)://)(www.)?(app.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)",
		'amount': "[a-zA-Z0-9\\*\\+\\-\\/]*",
		'phoneAll': /^[0-9]+$/,
	}
	chapter_versions = [
		// { 'version': 1 },
		// { 'version': 2 },
		// { 'version': 3 },
		{ 'version': 4 },
		{ 'version': 5 }
	]
	projectSelected: any = undefined;


	goBack() {
		if (window.history.length > 0) {
			window.history.back()
		} else {
			if (this.projectSelected) {
				this._router.navigate(['/projects', this.projectSelected.id]);
			} else {
				this._router.navigate(['/projects']);

			}
		}

	}
	getSeesion() {
		return this.session_token
	}
	setSession(token) {
		this.session_token = token;
		this.changesSessionToken$.next(token);
	}
	loadImage() {
		// Don't delete it
	}
	removeCookies() {
		this._cS.delete('plsu', '/');
		this._cS.deleteAll('/');
	}
	getSceneFormat(ev) {
		if (!ev) {
			return "--"
		} else if (Math.floor(ev) == ev) {
			return Math.floor(ev)
		} else {
			return ev
		}
	}
	getPages(ev) {
		if (!ev || ev == '--') {
			return null
		}
		var a = Math.floor(ev);
		var b = ev - a;
		var c = Math.floor(b / (1 / 8));
		return a + ' ' + c + '/8';
	}
	getPostTime(ev) {
		if (ev || ev == 0) {
			var a = ev / 23.97600000
			return this.getTime(a);
		} else {
			return '--:--'
		}
	}
	getTime(ev) {
		if (ev || ev == 0) {
			let sign = Math.sign(parseInt(ev));
			let isNegative = sign == -1 ? true : false;
			let value = Math.abs(parseInt(ev));

			let min = Math.floor(value / 60);
			let sec = value - (min * 60)
			if (sec < 10) {
				return isNegative ? `-${min}:0${sec}` : `${min}:0${sec}`;
			} else {
				return isNegative ? `-${min}:${sec}` : `${min}:${sec}`;
			}
		} else {
			return '--:--'
		}

	}
	getCurrentDate() {
		var d = new Date(),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();
	
		if (month.length < 2) 
			month = '0' + month;
		if (day.length < 2) 
			day = '0' + day;
	
		return [year, month, day].join('-');
		 
	}
	setLenguage() {
		if (!this._cS.check('Len')) {
			this._cS.set('Len', 'eng', 365, '/', undefined, undefined, 'Strict');
		}
	}
	changeLenguage(value?) {
		switch(value) {
			case 'eng': 
				this._cS.set('Len', 'eng', 365, '/', undefined, undefined, 'Strict');
			break;
			case 'esp':
				this._cS.set('Len', 'esp', 365, '/', undefined, undefined, 'Strict');
			break;
			case 'pt':
				this._cS.set('Len', 'pt', 365, '/', undefined, undefined, 'Strict');
			break;
			default:
				this._cS.set('Len', 'eng', 365, '/', undefined, undefined, 'Strict');
		}
		location.reload()
	}

	rigthClick(ev, elements, position = { 'left': 0, 'top': 0 }, offsetX = 200, offsetY = 20) {
		ev.preventDefault();
		this.showContext = true;
		let x = 0;
		let y = 0;
		let boxHeigth = (elements * offsetY) + 16;

		if (ev.clientY < (window.innerHeight - (boxHeigth))) {
			y = ev.clientY
		} else {
			y = window.innerHeight - (boxHeigth);
		}
		if (ev.clientX < (window.innerWidth - offsetX)) {
			x = ev.clientX
		} else {
			x = window.innerWidth - offsetX;
		}

		this.contextmenuy = (y + position.top) + 'px';
		this.contextmenux = (x + position.left) + 'px';
		this.validateContextPosition(ev, (x + position.left), (y + position.top));
	}

	validateContextPosition(ev, x, y) {
		setTimeout(() => {
			const GAP = 20;
			const THAT = this;
			Array.from(document.getElementsByClassName("contextmenu")).forEach(
				function (element: HTMLElement) {
					let height = element.offsetHeight;
					let width = element.offsetWidth;
					if (window.innerHeight < (height + y)) {
						THAT.contextmenuy = (window.innerHeight - height - GAP) + 'px';
					}
					if (window.innerWidth < (width + x)) {
						THAT.contextmenux = (window.innerWidth - width - GAP) + 'px';
					}
				}
			);
		});
	}

	openContextMenu(ev, height = 300, offsetX = 155, offsetY = 20) {
		ev.preventDefault();
		this.showContext = true;
		let x = 0;
		let y = 0;
		let boxHeigth = height;
		if (ev.clientY < (window.innerHeight - (boxHeigth))) {
			y = ev.clientY
		} else {
			y = window.innerHeight - (boxHeigth)
		}
		if (ev.clientX < (window.innerWidth - offsetX)) {
			x = ev.clientX
		} else {
			x = window.innerWidth - offsetX
		}

		this.contextmenuy = y + 'px';
		this.contextmenux = x + 'px';
	}

	hidemenu() {
		this.showContext = false;
	}
	getLenguage() {
		if (this._cS.check('Len')) {
			return this._cS.get('Len')
		} else {
			return 'eng'
		}

	}
	getReportLenguage() {
		switch (this.getLenguage()) {
			case 'esp':
				return 'ESP';
			case 'pt':
				return 'pt';
			case 'eng':
				return 'ENG';
			default:
				return '';
		}
	}
	backTranslate(item, value, textDefault?) {
		var a = item[value + '_' + this.getLenguage()];
		if (a) {
			return a
		} else {
			return textDefault ? textDefault : ''
		}
	}
	checkSubtittle(prod) {
		var a: string = "";
		var b: any = [];
		if (prod.production_center_id) {
			b.push(this.backTranslate(prod, 'prod_center'))
		}
		a = prod['project_status_name_' + this.getLenguage()];
		if (b.length > 0) {
			a += ' - ' + b.toString()
		}
		if (prod.production_start) {
			a += " " + this.datePipe.transform(prod.production_start, 'y')
		}
		return a
	}
	checkNullText(ev) {
		if (!ev) {
			return '--'
		}
		return ev
	}
	checkNullDate(ev) {
		if (ev) {
			return ev
		} else {
			return "--/--/----"
		}

	}
	formatTime(ev) {
		if (ev) {
			var a = ev.split(':')
			if (parseInt(a[0]) > 12) {
				var b = parseInt(a[0]) - 12
				return b + ':' + a[1] + ' pm'
			} else {
				return parseInt(a[0]) + ':' + a[1] + ' am'
			}
		} else {
			return "--:--"
		}
	}

	/** Get static string HH:mm (ignoring time zone) */
	getStaticStringHour(datetime): String {
		if (!datetime) {
			return "--:--";
		}
		const date = datetime.split('T')[0].split('-').map(d => parseInt(d))
		const time = datetime.split('T')[1] ? datetime.split('T')[1].split('.')[0].split(':') : null
		if (!time) {
			return "--:--";
		}

		date[1] = date[1] - 1; // months 0:jan - 11: dec
		const dateTime = new Date(date[0], date[1], date[2], time[0], time[1], time[2])
		return this.datePipe.transform(dateTime, 'HH:mm');
	}

	/** Get static Date object (ignoring time zone) */
	getStaticDateHour(datetime): Date {
		if (!datetime) {
			return null;
		}
		const date = datetime.split('T')[0].split('-').map(d => parseInt(d))
		const time = datetime.split('T')[1] ? datetime.split('T')[1].split('.')[0].split(':') : null
		if (!time) {
			return null;
		}
		date[1] = date[1] - 1; // months 0:jan - 11: dec
		const dateTime = new Date(date[0], date[1], date[2], time[0], time[1], time[2])
		return dateTime;
	}

	getRealDateHour(datetime: string): Date {
		if (!datetime) {
			return null;
		}
		
		const date = new Date(datetime);
		
		// Check if the date is valid
		if (isNaN(date.getTime())) {
			return null;
		}
		
		return date;
	}

	getRealHour(ev) {
		if (ev) {
			var Today = new Date();
			var returnTime = new Date(ev);
			var timezone = ev.split('-');
			timezone = parseInt(timezone[timezone.length - 1]);
			var dif = ((timezone * 60)) - returnTime.getTimezoneOffset();
			returnTime.setTime(returnTime.getTime() - (dif * 60 * 1000));
			return returnTime
		} else {
			return null
		}

	}
	validateAcces(ev: any, page?) {
		var us = JSON.parse(sessionStorage.getItem("pms_us"));
		this.user = us;
		// if (ev.id)
		if (!this.user) return false;
		if (!this.accessEnviromentIsValid(ev, page)) return false;
		if (us.user_role_id == 3) {
			if (this.projectSelected) {
				var b = this.projectSelected.id
				var found = us.projects.find(function (prj) {
					return prj.project_id == b;
				});
				const idArray = Array.isArray(ev.id) ? ev.id : [ev.id]
				const filter_secure_modueles = found.secure_modules.filter((el) => idArray.includes(el.secure_module_id))
				if(filter_secure_modueles){
					if (ev.type == 'read' && filter_secure_modueles.filter((el) => el.access > 0).length > 0){
						return true
					}
					if (ev.type == 'write' && filter_secure_modueles.filter((el) => el.access > 1).length > 0){
						return true
					}
				}
				// for (let sm of found.secure_modules) {
				// 	if (sm.secure_module_id == ev.id) {
				// 		if (ev.type == 'read' && sm.access > 0) {
				// 			return true
				// 		} else if (ev.type == 'write' && sm.access > 1) {
				// 			return true
				// 		}
				// 	}
				// }
			} else {
				const idArray = Array.isArray(ev.id) ? ev.id : [ev.id]
				const filter_secure_modueles = us.projects[0].secure_modules.filter((el) => idArray.includes(el.secure_module_id))
				if(filter_secure_modueles){
					if (ev.type == 'read' && filter_secure_modueles.filter((el) => el.access > 0).length > 0){
						return true
					}
					if (ev.type == 'write' && filter_secure_modueles.filter((el) => el.access > 1).length > 0){
						return true
					}
				}
				// for (let sm of us.projects[0].secure_modules) {
				// 	if (sm.secure_module_id == ev.id) {
				// 		if (ev.type == 'read' && sm.access > 0) {
				// 			return true
				// 		} else if (ev.type == 'write' && sm.access > 1) {
				// 			return true
				// 		}
				// 	}
				// }
			}
		} else {
			if(ev.id){
				const idArray = Array.isArray(ev.id) ? ev.id : [ev.id]
				const filter_secure_modueles = us.secure_modules.filter((el) => idArray.includes(el.secure_module_id))
				if(filter_secure_modueles){
					if (ev.type == 'read' && filter_secure_modueles.filter((el) => el.access > 0).length > 0){
						return true
					}
					if (ev.type == 'write' && filter_secure_modueles.filter((el) => el.access > 1).length > 0){
						return true
					}
				}
					
			}
			
			// for (let sm of us.secure_modules) {
			// 	if (sm.secure_module_id == ev.id) {
			// 		if (ev.type == 'read' && sm.access > 0) {
			// 			return true
			// 		} else if (ev.type == 'write' && sm.access > 1) {
			// 			return true
			// 		}
			// 	}
			// }
		}
		return false
	}

	accessEnviromentIsValid(ev, page): boolean {
		let blockAccess = ENV_BLOCKED_ACCESS.find(e => e.env == environment.appEnv);
		if (blockAccess && blockAccess.pages.find(p => p == ev.id)) return false;
		if (page && page.hiddenOnEnv && page.hiddenOnEnv.find(ph => ph == environment.appEnv)) return false;

		// Chapters is not shown if project type is 2 (Feature film)
		if (this.projectSelected && this.projectSelected.project_type_id == 2 && ev.id == 6) return false;
		return true;
	}

	cssPagedMedia(size) {
		var style = document.createElement('style');
		document.head.appendChild(style);
		style.innerHTML = '@page {size: ' + size + '}';
	}

	trackById(index, item) {
		return item.id;
	}

	trackByProperty(property) {
		return function (index, item) {
			return item[property];
		}
	}

	setMockImages(list, property = 'image_url', useIds = false) {
		for (let i = 0; i < list.length; i++) {
			if (useIds) {
				list[i][property] = `https://picsum.photos/id/${(i + 1) * 10}/200/300`;
				continue;
			}
			list[i][property] = "https://picsum.photos/200/300?random=" + (i + 1);
		}
	}

	getTranslateProperty(property) {
		let a = property + '_' + this.getLenguage()
		return a;
	}

	getFileExtension(file_unsigned) {
		return file_unsigned ? file_unsigned.split('.')[file_unsigned.split('.').length - 1] : null;
	}

	/**
	 * 
	 * @param file_unsigned
	 * @param numberOfSubFolders Número de carpetas antes de llegar archivo. Ej: projects/expenses/file.pdf => numberOfSubFolders = 2
	 */
	getFileName(file_unsigned, numberOfSubFolders) {
		return file_unsigned ? file_unsigned.split('/')[numberOfSubFolders] : null;
	}


	checkSceneClass(scn) {
		let a = ''
		if (scn.scene_status_id == 1) {
			a += ' pre-breakdown'
		} else if (scn.scene_status_id == 2) {
			a += ' private'
		} else if (scn.scene_status_id == 3) {
			a += ' not-assigned'
		} else if (scn.scene_status_id == 4) {
			a += ' assigned'
		} else if (scn.scene_status_id == 5) {
			a += ' produced'
		} else if (scn.scene_status_id == 8) {
			a += ' cancel'
		}
		if (scn.scene_type_id == 2) {
			a += ' protection'
		}
		return a;
	}

	getValidDateTimezone(ev?): Date {
		let a = ev ? new Date(ev) : new Date();
		a = new Date(a.setTime(a.getTime() + a.getTimezoneOffset() * 60 * 1000));
		return a;
	}

	adjustDate(dateToAdjust): Date {
		if (!dateToAdjust) return null;
		let d = new Date(dateToAdjust);
		d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
		return d;
	}

	/** Pagination options */

	savePagination(newStart: number, paginationOptions: PaginationOptions) {
		paginationOptions.sliceStart = newStart;
		let savedPaginations = <PaginationOptions[]>JSON.parse(sessionStorage.getItem('tables-paginations')) || [];
		let indexFound = savedPaginations.findIndex(s => s.tableName == paginationOptions.tableName);

		if (indexFound < 0) {
			savedPaginations.push(paginationOptions);
			sessionStorage.setItem('tables-paginations', JSON.stringify(savedPaginations));
			return;
		}

		savedPaginations.splice(indexFound, 1, paginationOptions);
		sessionStorage.setItem('tables-paginations', JSON.stringify(savedPaginations));
	}

	getPagination(name: string, sliceSize = 30): PaginationOptions {
		let paginationOptions = {
			'sliceSize': sliceSize,
			'sliceStart': 0,
			'tableName': name
		}
		try {
			let savedPaginations = <PaginationOptions[]>JSON.parse(sessionStorage.getItem('tables-paginations'));
			if (!savedPaginations) return paginationOptions;
			let foundConfig = savedPaginations.find(s => s.tableName == name);
			return foundConfig ? foundConfig : paginationOptions;
		} catch (err) {
			return paginationOptions;
		}
	}

	removePagination(name: string) {
		let savedPaginations = <PaginationOptions[]>JSON.parse(sessionStorage.getItem('tables-paginations'));
		if (!savedPaginations) return;
		let indexFound = savedPaginations.findIndex(s => s.tableName == name);
		if (indexFound < 0) return;
		savedPaginations.splice(indexFound, 1);
		sessionStorage.setItem('tables-paginations', JSON.stringify(savedPaginations));
	}

	/** Saved Table Headers  */

	saveHeadersTable(headers: any, tableName: string) {
		let options = {
			'tableName': tableName,
			'headers': headers
		}
		let savedTableHeaders = JSON.parse(localStorage.getItem('tables-headers')) || [];
		let indexFound = savedTableHeaders.findIndex(s => s.tableName == tableName);
		if (indexFound < 0) {
			savedTableHeaders.push(options);
			localStorage.setItem('tables-headers', JSON.stringify(savedTableHeaders));
			return;
		}
		savedTableHeaders.splice(indexFound, 1, options);
		localStorage.setItem('tables-headers', JSON.stringify(savedTableHeaders));
	}

	getHeaderTable(tableName: string, headers: any, indexVersion = 0) {
		try {
			let savedTableHeaders = JSON.parse(localStorage.getItem('tables-headers'));
			if (!savedTableHeaders) return headers;

			let indexFound = savedTableHeaders.findIndex(s => s.tableName == tableName);
			if (indexFound < 0) return headers;

			if (this.versionTableIsValid(savedTableHeaders[indexFound], headers, indexVersion)) {
				return savedTableHeaders[indexFound].headers;
			}
			savedTableHeaders.splice(indexFound, 1);
			localStorage.setItem('tables-headers', JSON.stringify(savedTableHeaders));
			return headers
		} catch (err) {
			return headers;
		}
	}

	versionTableIsValid(savedHeaders: any, headers: any, indexVersion = 0) {
		if (!savedHeaders || !savedHeaders.headers) return false;
		let savedVersion = savedHeaders.headers[indexVersion].version_table;
		if (savedVersion && savedVersion == headers[indexVersion].version_table) {
			return true;
		}
		return false;
	}


	/**
	 * Adds code filters that are missing on local storage filters.
	 */
	validateFilterWithLocalStorage(storedFilters, filters) {
		Object.keys(filters).map((key) => {
			if (!storedFilters.hasOwnProperty(key)) {
				storedFilters[key] = filters[key];
			}
		});
		return storedFilters;
	}

	getFileType(extension): string {
		if (extension.toLowerCase() == 'pdf') return 'pdf';
		if (extension.toLowerCase() == 'xlsx' ||
			extension.toLowerCase() == 'xlsm' ||
			extension.toLowerCase() == 'xls') {
			return 'excel';
		}
		return 'image';
	}

	formatVideosCIResponse(data: any): any[] {
		if(!data.videos)return []
		return data.videos.map(video => {
			const video_data = video.videos && video.videos.length ? video.videos[0] : null;
			if (!video_data) return null;
			return {
				clip_name: video_data.name,
				clip_url: video_data.versions[0]?.location || null,
				clip_thumbnails: video_data.thumbnails[0]?.location || null,
				unit_number: video.info_shoot?.unit_number || null,
				date: video.info_shoot?.date || null,
				selected_clip: video.info_shoot?.selected_clip || null,
				directorsNotes: video.info_shoot?.director_notes || null,
				descriptions: video.info_shoot?.description || null,
			}
		}).filter(x => x != null);
	}

	roundPagesFraction(value) {
		let pages = Math.floor(value);
		let fractions = Math.round((parseFloat(value) - pages) * 8);
		let a: number = pages ? pages : 0;
		let b: number = fractions ? fractions : 0;
		return a + (b / 8);
	}

	getHeightGraph(element, max?) {
		let computedStyle = getComputedStyle(element);
		let elementHeight = element.clientHeight;  // height with padding
		elementHeight -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
		if (max) {
			return elementHeight > max ? max : elementHeight - 6;
		}
		return elementHeight - 6;
	}

	/** Useful when not using the properties of contextmenu from comun service */
	validateContextPositionManual(x: number, y: number): { x: number, y: number } {
		const GAP = 20;
		let context = { x: x, y: y };
		Array.from(document.getElementsByClassName("ctx-validate")).forEach(
			function (element: HTMLElement) {
				let height = element.offsetHeight;
				let width = element.offsetWidth;
				if (window.innerHeight < (height + y)) {
					context.y = (window.innerHeight - height - GAP);
				}
				if (window.innerWidth < (width + x)) {
					context.x = (x - width - GAP);
				}
				return context;
			}
		);
		return context;
	}

	isLastDayOfMonth(dt: Date): boolean {
		return new Date(dt.getTime() + 86400000).getDate() === 1;
	}

	isFirstDayOfMonth(dt: Date): boolean {
		return dt.getDate() === 1;
	}

	toggleGraphFullscreen(graphsFullScreen, ev) {
		graphsFullScreen[ev] = !graphsFullScreen[ev];
	}

	getScenesPerEpisodeByStatus(): any[] {
		return [
			{ name: "Day int", value: "scenes_day_int", type: "bg-white" },
			{ name: "Day ext", value: "scenes_day_ext", type: "bg-yellow" },
			{ name: "Night int", value: "scenes_night_int", type: "bg-green" },
			{ name: "Night ext", value: "scenes_night_ext", type: "bg-blue" },
		]
	}

	getPreviousMonday(date): Date {
		let prevMonday = this.adjustDate(date);
		if (prevMonday.getDay() != 1) {
			prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);
		}
		return prevMonday;
	}

	getSceneDayNightIntExtClass(dayNightId: DAY_NIGHT_OPTIONS, intExtId: INT_EXT_OPTIONS, item?: any) {
		if (intExtId == INT_EXT_OPTIONS.Interior) {
			switch (dayNightId) {
				case DAY_NIGHT_OPTIONS.Day:
				case DAY_NIGHT_OPTIONS.Sunrise:
					return "bg-day-int";
				case DAY_NIGHT_OPTIONS.Night:
				case DAY_NIGHT_OPTIONS.Sunset:
					return "bg-night-int"
			}
		} else if (intExtId == INT_EXT_OPTIONS.Exterior || intExtId == INT_EXT_OPTIONS.IntExt || intExtId == INT_EXT_OPTIONS.ExtInt) {
			switch (dayNightId) {
				case DAY_NIGHT_OPTIONS.Day:
				case DAY_NIGHT_OPTIONS.Sunrise:
					return "bg-day-ext";
				case DAY_NIGHT_OPTIONS.Night:
				case DAY_NIGHT_OPTIONS.Sunset:
					return "bg-night-ext"
			}
		}
		else if (item.type_array == 2) {
			return 'bann';
		}
		else {
			return "";
		}
	}

	generateImagesDrawing(drawings: any[], canvasId = 'canvas_hidden') {
		let canvas = document.createElement('canvas');
		canvas.style.display = 'none';
		canvas.id = 'canvas_hidden';
		document.body.appendChild(canvas);

		drawings.map(drawing => {
			let sketchpad = this.loadSketch(drawing, `#${canvasId}`);
			drawing.canvas_image = sketchpad.canvas.toDataURL();
		});
		canvas.remove();
	}

	loadSketch(sketch, id) {
		let parsed = JSON.parse(sketch.json);
		parsed.element = id;
		return new Sketchpad(parsed);
	}

	updateTreeValidity(group: UntypedFormGroup | UntypedFormArray): void {
		Object.keys(group.controls).forEach((key: string) => {
			const abstractControl = group.controls[key];

			if (abstractControl instanceof UntypedFormGroup || abstractControl instanceof UntypedFormArray) {
				this.updateTreeValidity(abstractControl);
			} else {
				abstractControl.updateValueAndValidity();
			}
		});
	}

	setPopupEditData(item: any, title:string, var_name: string, formType: string, inputType?: string, list?: any[]) {
		let data = {
			item: item,
			title: title,
			formType: formType,
			inputType: inputType,
			list: list,
			var_name: var_name
		}
		return data;
	}

	parseDateToString(date) {
		const year = date.getFullYear();
    	const month = String(date.getMonth() + 1).padStart(2, "0");
    	const day = String(date.getDate()).padStart(2, "0");
		return `${year}-${month}-${day}`;
	}

	constructor(
		private breakpointObserver: BreakpointObserver,
		private _cS: CookieService,
		private datePipe: DatePipe,
		private _router: Router,
		private route: ActivatedRoute) {
		this.breakpointObserver.observe([('(max-width: 1100px), (hover: none)')]).subscribe(
			(data: any) => {
				this.isMobile$.next(data.matches);
			}
		)
	}
}
